import { initScheduledJobsRunner } from '@common/utils/jobs/jobUtils'
import { LoadRum24x7 } from '@common/utils/rum24x7'
import { setDebugMode } from '@common/utils/setDebugMode'
import { onWindowResize } from '@common/utils/window/onWindowResize'
import { scrollbarWidthUnits } from '@common/utils/window/scrollbarWidthUnits'
import { verticalHeightUnits } from '@common/utils/window/verticalHeightUnits'
import { initialiseLogger as initialiseOmniaUiLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import type { InitializeResult } from './content/services/cms.service'
import { gtm } from './content/services/gtm/gtm.service'
// import { initialiseLogger } from './content/services/logger/logger.service'

/**
 * Handles running anything that must be ran AFTER initial data is available but BEFORE <App /> is rendered
 */
export const init = (occConfigurationApi: InitializeResult) => {
    // Create logger always as first step
    initialiseOmniaUiLogger(occConfigurationApi?.loggingConfiguration || [])
    // initialiseLogger(occConfigurationApi?.loggingConfiguration || [])

    // Services.NavigationService = navigationService as any

    // A checker for scheduled jobs in FE
    initScheduledJobsRunner()
    // Generate vertical height units
    verticalHeightUnits()
    scrollbarWidthUnits()

    // const isProd = process.env.production // Leaving in case we need it in the future
    // Code to run every time window resizes
    onWindowResize(() => {
        verticalHeightUnits()
        scrollbarWidthUnits()
    })

    setDebugMode()

    // If we want to load captcha script programmatically instead of in the template
    // if (occConfigurationApi.recaptcha.siteKey)
    //     loadScript('recaptchaScript', 'https://www.google.com/recaptcha/api.js')

    // Load RUM
    if (occConfigurationApi.rumId) LoadRum24x7(occConfigurationApi.rumId)

    if (occConfigurationApi.country) {
        if (IS_STORYBOOK) {
            document.documentElement.setAttribute('data-tenant', 'finnkino')
        } else {
            document.documentElement.setAttribute('data-tenant', occConfigurationApi.country.toLowerCase()) // 'uk'
        }
    }

    const rootDiv = document.getElementById('root')
    if (rootDiv) {
        // Adding a country class to root DIV for all conditional CSS
        rootDiv.className = occConfigurationApi.country
        gtm.initializeGoogleTags(occConfigurationApi.gtmId)
    }

    // Update MX trailers
    // TODO: remove mx trailers from backend as well
    // try {
    //     if (occConfigurationApi.mxTrailers) {
    //         const cacheDuration = getCacheDuration('films')
    //         runInAction(() => {
    //             Object.entries(occConfigurationApi.mxTrailers).forEach(([filmId, trailerUrl]) => {
    //                 const filmTrailer = createFetchedData(trailerUrl ?? undefined, cacheDuration)
    //                 browsingDomainStore.data.trailerUrlsByFilmId[filmId] = filmTrailer
    //             })
    //         })
    //     }
    // } catch {
    //     /* */
    // }
}
